export default __webpack_public_path__ + "static/media/rabbit-bone.23708e12.png";